import { render, staticRenderFns } from "./TabAlgemeen.vue?vue&type=template&id=2eb06e27"
import script from "./TabAlgemeen.vue?vue&type=script&lang=js"
export * from "./TabAlgemeen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports